import { DwspayPaymentSummary } from '@services/dws/ws-payments.service';
import {
  AdvancedExportFormat,
  PaymentsAdvancedExport,
} from './payments-advanced-export';

/** List API page size for export (larger than UI paginator — fewer round trips). */
export const EXPORT_PAGE_SIZE = 500;

export type PaymentsListExportFormat = AdvancedExportFormat;

export const mapSummaryToExportRow = (raw: DwspayPaymentSummary) =>
  PaymentsAdvancedExport.mapWinesuiteSummaryToExportRow(raw);

export const buildListExportFile = PaymentsAdvancedExport.buildListFilteredExportFile;
